import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {},
	theme: {
		base: {
			application: {
				font: {
					family: 'Arial',
				},
			},
			button: {},
			card: {
				children: {
					header: {
						background: {
							color: 'initial',
						},
					},
					wrapper: {
						border: {
							_value: 'none',
						},
					},
				},
			},
			icon: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-icon"]',
								style: {
									verticalAlign: 'middle',
								},
							},
						],
					},
				},
			},
			actions: {
				children: {
					wrapper: {
						display: 'flex',
					},
				},
			},
			list: {
				children: {
					placeholder: {
						font: {
							style: 'italic',
						},
					},
					heading: {
						display: 'flex',
						overrides: [
							{
								selector: '[data-selector="base-list-multipartListHeading"]',
								style: {
									flex: {
										_value: 'auto',
									},
								},
							},
							{
								selector: '[data-selector="base-list-multipartListHeading"]:last-child',
								style: {
									flex: {
										grow: '0',
									},
								},
							},
						],
					},
					multipartListItem: {
						display: 'flex',
						padding: {
							top: '4px',
							bottom: '4px',
						},
						border: {
							bottom: {
								_value: '1px solid #999',
							},
						},
					},
					listItem: {
						border: {
							bottom: {
								_value: '1px solid #999',
							},
						},
						padding: {
							top: '10px',
							bottom: '10px',
						},
					},
					content: {
						flex: {
							_value: 'auto',
						},
					},
					firstContent: {
						flex: {
							_value: 'auto',
						},
					},
					lastContent: {
						flex: {
							grow: '0',
						},
					},
					listItemWrapper: {
						listStyle: {
							type: 'none',
						},
					},
					unorderedList: {
						listStyle: {
							type: 'none',
						},
						margin: {
							block: {
								start: '0px',
								end: '0px',
							},
							inline: {
								start: '0px',
								end: '0px',
							},
						},
						padding: {
							inline: {
								start: '0px',
								end: '0px',
							},
						},
					},
				},
			},
			scaleLegend: {
				children: {
					wrapper: {
						width: '300px',
						overrides: [
							{
								selector: '[data-selector="base-list-content"]',
								style: {
									flex: {
										_value: '1 1 50%',
									},
								},
							},
							{
								selector: '[data-selector="base-list-multipartListItem"]',
								style: {
									border: {
										bottom: {
											_value: 'none',
										},
									},
								},
							},
						],
					},
				},
			},
			image: {
				children: {
					styledImage: {
						verticalAlign: 'middle',
					},
				},
			},
			checkbox: {
				children: {
					icon: {
						verticalAlign: 'middle',
					},
				},
			},
			asset: {},
			link: {},
			contextMenu: {
				children: {
					button: {
						border: {
							style: 'none',
						},
						outline: {
							style: 'none',
						},
						font: {
							size: '13px',
						},
						lineHeight: '34px',
					},
					icon: {
						verticalAlign: 'middle',
					},
					dropdown: {
						margin: {
							top: '2px',
						},
						padding: {
							_value: '5px',
						},
						border: {
							color: '#cccccc',
							style: 'solid',
							width: 'thin',
							radius: '3px',
						},
						position: 'absolute',
						min: {
							width: '100px',
						},
						background: {
							color: 'white',
						},
					},
					dropdownItem: {
						display: 'block',
						font: {
							size: '13px',
						},
						lineHeight: '34px',
					},
					clickLayer: {
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
					},
				},
			},
			table: {
				width: '100%',
				overrides: [
					{
						selector: 'div[data-selector="base-tooltip-tooltipContent"]',
						style: {
							color: '#333333',
						},
					},
				],
				children: {
					table: {
						width: '100%',
						font: {
							family: 'Arial',
						},
					},
					head: {
						overrides: [
							{
								selector: 'tr:nth-child(1) th',
								style: {
									color: '#0079C1',
									font: {
										size: '18px',
									},
								},
							},
							{
								selector: 'tr:nth-child(2) th',
								style: {
									// border: {
									// 	bottom: {
									// 		_value: '2px solid #0079C1',
									// 	},
									// },
								},
							},
						],
					},
					headRow: {
						height: '55px',
					},
					headCell: {
						padding: {
							right: '16px',
						},
						text: {
							align: 'right',
						},
						font: {
							size: '16px',
							weight: 'bold',
						},
						lineHeight: '20px',
					},
					headCellSubTitle: {
						color: 'grey',
						font: {
							size: '14px',
						},
					},
					body: {
						font: {
							size: '16px',
						},
						color: '#001928',
						lineHeight: '24px',
					},
					row: {
						height: '55px',
						background: {
							color: '#FFFFFF',
						},
						selectors: [
							{
								':nth-child': {
									_parameters: ['odd'],
									background: {
										color: '#F5F6F7',
									},
								},
							},
						],
					},
					cell: {
						border: {
							bottom: {
								color: '#C7C7C7',
								width: '1px',
								style: 'solid',
							},
						},
						selectors: [
							{
								':first-child': {
									text: {
										align: 'left',
									},
									padding: {
										left: '16px',
									},
								},
							},
						],
						text: {
							align: 'right',
						},
						padding: {
							right: '16px',
						},
					},
					disclaimersWrapper: {
						margin: {
							top: '20px',
						},
					},
				},
			},
			asOfDate: {},
			tooltip: {
				children: {
					wrapper: {
						display: 'inline-block',
						verticalAlign: 'text-bottom',
						overrides: [
							{
								selector: '[data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									position: 'absolute',
								},
							},
							{
								selector:
									'div[data-placement="top"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									bottom: '-14px',
								},
							},
							{
								selector:
									'div[data-placement="bottom"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									top: '-13px',
									transform: 'rotate(180deg)',
								},
							},
							{
								selector:
									'div[data-placement="left"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									right: '-11px',
									transform: 'rotate(-90deg)',
								},
							},
							{
								selector:
									'div[data-placement="right"] [data-selector="base-tooltip-arrowIconWrapper"]',
								style: {
									left: '-11px',
									transform: 'rotate(90deg)',
								},
							},
							{
								selector:
									'div[data-selector="base-tooltip-tooltipContentWrapper"]',
								style: {
									zIndex: '3',
								},
							},
						],
					},
					tooltipIconButton: {
						cursor: 'pointer',
						position: 'sticky',
						zIndex: '2',
					},
					tooltipCharacter: {
						font: {
							size: '9px',
						},
						min: {
							width: '1.5em',
						},
						margin: {
							_value: '0 0.5em',
						},
						padding: {
							top: '0.2em',
							bottom: '0.2em',
							left: '0.5em',
							right: '0.5em',
						},
						color: 'white',
						background: {
							color: '#1EA7FD',
						},
						border: {
							radius: '1.5em',
						},
						text: {
							align: 'center',
						},
					},
					tooltipIcon: {
						width: '16px',
						height: '16px',
					},
					tooltipContent: {
						max: {
							width: '250px',
						},
						background: {
							color: 'white',
						},
						border: {
							style: 'solid',
							width: '1px',
							color: '#cccccc',
							radius: '3px',
						},
						box: {
							shadow: '2px 2px 0 rgba(0,0,0,0.1)',
							sizing: 'border-box',
						},
						padding: {
							_value: '4px',
						},
						font: {
							size: 'smaller',
						},
						text: {
							align: 'center',
						},
						margin: {
							_value: '3px',
							bottom: '2px',
						},
					},
					clickLayer: {
						position: 'fixed',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
						zIndex: '3',
					},
					arrowIcon: {
						fill: 'white',
						stroke: '#cccccc',
					},
				},
			},
		},
		overview: {
			changeIndicator: {
				children: {
					wrapper: {
					},
					valueDown: {
						color: 'red',
					},
					valueUp: {
						color: 'green',
					},
					icon: {
						height: '30px',
						width: '30px',
						padding: {
							bottom: '5px',
						},
					},
				},
			}
		}
	},
};